import { render, staticRenderFns } from "./AdminIframeContent.vue?vue&type=template&id=d3774fcc&"
import script from "./AdminIframeContent.vue?vue&type=script&lang=ts&"
export * from "./AdminIframeContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports